import { Lessons } from '../../../src_server/entity/generated/Lessons';


import { LessonReservationDTO } from '../../../src_server/entity/dto/LessonReservationDTO';


import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class LessonsService extends GeneratedBizBase{
  async getLesson(class_id: number): Promise<Response<Lessons>> {
    return super.restCall<Response<Lessons>>('get', '/v1/LessonsService/getLesson', arguments);
  }
  async reservation(stu_user_id: string,teacher_user_id: string,start_dt: string,end_dt: string,shift_table_id: number): Promise<Response<LessonReservationDTO>> {
    return super.restCall<Response<LessonReservationDTO>>('post', '/v1/LessonsService/reservation', arguments);
  }
  async getLessonByTeacherUserId(tea_user_id: string,fromDate: string,toDate: string): Promise<Response<Lessons[]>> {
    return super.restCall<Response<Lessons[]>>('get', '/v1/LessonsService/getLessonByTeacherUserId', arguments);
  }
  async getLessonByStudentIdForCoDashboard(student_id: string,start_dt: string,end_dt: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getLessonByStudentIdForCoDashboard', arguments);
  }
  async getCommitedLessonByTerm(student_id: string,from: string,to: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getCommitedLessonByTerm', arguments);
  }
  async getLessonState(student_id: string,teacher_id: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getLessonState', arguments);
  }
  async getRequestedLessonsForTeacher(tea_user_id: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getRequestedLessonsForTeacher', arguments);
  }
  async getRequestedLessonsForTeacherBetween(tea_user_id: string,start: string,end: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getRequestedLessonsForTeacherBetween', arguments);
  }
  async getLessonsBetweenByTeacher(tea_user_id: string,from_date: string,to_date: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getLessonsBetweenByTeacher', arguments);
  }
  async getLessonsByTeacher(tea_user_id: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getLessonsByTeacher', arguments);
  }
  async allReservationCommit(params: LessonDTO[],building: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/LessonsService/allReservationCommit', arguments);
  }
  async reservationCommit(lesson: Lessons,building: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/LessonsService/reservationCommit', arguments);
  }
  async getLessonDto(class_id: number): Promise<Response<LessonDTO>> {
    return super.restCall<Response<LessonDTO>>('get', '/v1/LessonsService/getLessonDto', arguments);
  }
  async getLessonDtoByBuilding(building_id: string,from: string,to: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getLessonDtoByBuilding', arguments);
  }
  async getLessonDtoByTeacherId(teacher_id: string,from: string,to: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getLessonDtoByTeacherId', arguments);
  }
  async getLessonsStateForTeacher(tea_user_id: string,from: string,to: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getLessonsStateForTeacher', arguments);
  }
  async getLessonsStateForStudent(stu_user_id: string,from: string,to: string,building_id: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getLessonsStateForStudent', arguments);
  }
  async getLessonsForStudentWithoutTerm(stu_user_id: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getLessonsForStudentWithoutTerm', arguments);
  }
  async getLessonsBetweenAndStudentId(student_id: string,from: string,to: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('get', '/v1/LessonsService/getLessonsBetweenAndStudentId', arguments);
  }
  async cancel(original_class_id: number,building_id: string,reason: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/LessonsService/cancel', arguments);
  }
  async studentShown(class_id: number): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/LessonsService/studentShown', arguments);
  }
  async updateOneComment(class_id: number,comment: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/LessonsService/updateOneComment', arguments);
  }
  async getMonthlyCanceledLesson(month1Date: Date,building_id: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('post', '/v1/LessonsService/getMonthlyCanceledLesson', arguments);
  }
}
